/* eslint-disable */
import _Vue from "vue";

export default class GdaClient {

  isLoaded = false;

  gdaProxy: any = null;
  gdaPoupWindow: WindowProxy | null = null;
  //GDA XDM Funktions-Queue - onReady
  functionQueueWaitForReady: Function[] = [];
  gisReadyTimer: any = null;

  config = {
    recieveCoordinate: (() => {
    }) as any ,
    externalBaseUrl: "http://www.gda-wasser.rlp.de/GDAWasser/client/xdm/", //Default für Live Umgebung GDA Wasser
    externalApplicationId: null,
    dspfUserId: null,
    datascoutBaseURL: "https://datascout.rlp-umwelt.de/", //Default für Live Umgebung Datascout
    winOpts: "width=900,height=600,top=50,left=50,resizable=yes", //Default
  };

  constructor(settings: any) {
    //Bugfix 01.04.2015: wenn Debug-Console im IE nicht geöffnet ist, Dummy initialisieren, damit alles dennoch funktioniert.
    if (!window.console) window.console = {} as Console;
    if (!window.console.log) window.console.log = () => {};

    if (settings) {
      this.config = Object.assign(this.config, settings);
    }
  }

  /** Allgemeine Initialisierung */
  init() {
    // Prüfen, ob easyXDM vorhanden ist
    // @ts-ignore
    if(window.easyXDM  == undefined) {
      throw new Error("Fehler GDA: EasyXDM konnte nicht gefunden werden.");
    }
    // Prüfen, ob alle Konfigurationsparameter definiert wurden
    if (typeof this.config.externalBaseUrl == "undefined") {
      throw new Error(
        'Fehler GDA-Schnittstelle: Die Javascript Variable "externalBaseUrl" ist nicht definiert -> bitte auf der aufrufenden Seite einbauen',
      );
    }
    if (typeof this.config.externalApplicationId == "undefined") {
      throw new Error(
        'Fehler GDA-Schnittstelle: Die Javascript Variable "externalApplicationId" ist nicht definiert -> bitte auf der aufrufenden Seite einbauen',
      );
    }
    if (typeof this.config.dspfUserId == "undefined") {
      throw new Error(
        'Fehler GDA-Schnittstelle: Die Javascript Variable "dspfUserId" ist nicht definiert -> bitte auf der aufrufenden Seite einbauen',
      );
    }
    // erzeuge gdaProxy wenn keiner gegeben ist
    if (this.gdaProxy == null) {
      if (
        this.config.datascoutBaseURL != null &&
        this.config.dspfUserId != null
      ) {
        // Erzeugen eines Datascout-Tickets für den SSO-zugagn zu GDA, Hinzufügen als Javascript-Variable
        const ticketURL =
          this.config.datascoutBaseURL +
          "servlet/is/global." +
          this.config.dspfUserId +
          ".generateTicket/?asJavascript=true";
        // Ticket holen
        this._getScript(ticketURL, () => {
          this._initGDAClient();
        });
      } else this._initGDAClient();
    } else this.isLoaded = true;
  }

  // ------ Methods for common GDA API functions -------

  viewCoordinate(rechtswert: any, hochwert: any) {
    this._openGDAPopup();

    var coordinate: any = null;
    var boundingBox: any = null;
    if (rechtswert != null && hochwert != null) {
      coordinate = [rechtswert, hochwert];
      boundingBox = [
        rechtswert - 100,
        hochwert - 30,
        rechtswert + 100,
        hochwert + 30,
      ];
    }

    this._sendGDARequestWhenReady(() => {
      this.gdaProxy.postMessage({
        action: "showCoordinate",
        coord: coordinate,
      });
    });

    this._sendGDARequestWhenReady(() => {
      if (coordinate != null) {
        this.gdaProxy.postMessage({
          action: "zoomTo",
          obj: boundingBox,
        });
      }
    });
  }

  /**
   * Methode zum Editieren einer Punkt-Koordinate.
   * Die Koordinate wird Fachobjkekt-unabhängig in GDA editiert (verschoben) oder neu gesetzt (beim Aufruf mitNULL als Rechtswert/Hochwert)
   * Die Speicherung der Koordinate erfolgt nicht über GDA Wasser, sondern die Koordinate wird beim Schließen an die Fachanwednung
   * zurück übergeben. Hierfür muss zusätzlich die Methode "recieveCoordinate" lokal implementiert werden, die die Koordinate
   * entgegennimmt und verarbeitet
   */
  editCoordinate(rechtswert: any, hochwert: any) {
    this._openGDAPopup();

    var coordinate: any = null;
    var boundingBox: any = null;
    if (rechtswert != null && hochwert != null) {
      coordinate = [rechtswert, hochwert];
      boundingBox = [
        rechtswert - 100,
        hochwert - 30,
        rechtswert + 100,
        hochwert + 30,
      ];
    }

    this._sendGDARequestWhenReady(() => {
      this.gdaProxy.postMessage({
        action: "createOrEditCoordinate",
        coord: coordinate,
      });
    });

    this._sendGDARequestWhenReady(() => {
      if (coordinate != null) {
        this.gdaProxy.postMessage({
          action: "zoomTo",
          obj: boundingBox,
        });
      }
    });
  }

  /**
   * Methode zum Editieren einer Geometrie.
   * Die Geometrie wird gehighlightet und kann in GDA Wasser bearbeitet und via WFST gespeichert werden.
   * Voraussetzung für die Nutzung dieser Methode ist, dass Der Layer mit seinem Schlüsselattribut
   * GDA-seitig in ExternalAppConfig.js registriert ist -> bei Rückfragen hierzu: Udo Keim oder init.
   */
  editGeometry(layername: any, keysToEdit: any) {
    this._openGDAPopup();
    this._sendGDARequestWhenReady(() => {
      this.gdaProxy.postMessage({
        action: "createOrEditObject",
        layerName: layername,
        keys: keysToEdit,
        persistObject: true,
      });
    });
  }

  /* Methode zum Highlighten einer Geometrie.
   * Die Geometrie wird auf dem Layer hervorgehoben, die überigen Geometrieb sind jedoch ebenfalls
   * sichtbar.
   * Voraussetzung für die Nutzung dieser Methode ist, dass Der Layer mit seinem Schlüsselattribut
   * GDA-seitig in ExternalAppConfig.js registriert ist -> bei Rückfragen hierzu: Udo Keim oder init.
   **/
  highlightGeometry(layername: any, keysToHighlight: any) {
    this._openGDAPopup();

    this._sendGDARequestWhenReady(() => {
      this.gdaProxy.postMessage({
        action: "showKeys",
        layerName: layername,
        keys: keysToHighlight,
      });
    });
  }


  activateLayer(layernames: any) {
    this._openGDAPopup();

    this._sendGDARequestWhenReady(() => {
      this.gdaProxy.postMessage({
        action: "activateLayers",
        layerNames: layernames,
      });
    });
  }



  /**
   * Methode zur Darstellung (Filterung) einer Geometrie auf einem Layer, z.B. um eine einzelne Klüranlage auf den Kläranlagen-Layer darzustellen.
   * Wichtig: für die Nutzung dieser Methode ist KEIN Eintrag in der ExternalAppConfig.js nötig!
   * Parameter:
   * - Layername: Name des Fachlayers auf den gefiltert werden soll
   * - FilterKey: Name des Attributs ( FeatureTypes), auf welchen gefitlert werden soll
   * - FitlerValues: Filterwerte (Schlüssel)
   * - Rechtswert/Hochwert: optionale Angabe zum Zoomen auf den Kartenausschnitt, insbes. bei Punktgeometrien
   * bei anderen Geometrien muss der Kartenausschnitt anderweitig ermittelt werden, es kann dann mittels "zoomKarte" ein Kartenausschnitt gezeigt werden.
   */
  filterObjektOnLayer(
    layername: any,
    filterKey: any,
    filterValues: any,
    rechtswert?: any,
    hochwert?: any,
  ) {
    this._openGDAPopup();

    /*
    this._sendGDARequestWhenReady(() => {
      this.gdaProxy.postMessage({
        action: "activateLayers",
        layerNames: [layername],
      });
    });
    */


    if(filterValues != null && filterValues.length > 0)
    this._sendGDARequestWhenReady(() => {
      this.gdaProxy.postMessage({
        action: "filterByKey",
        layerName: layername,
        filterKey: filterKey,
        filterValues: filterValues,
      });
    });

    //bei Angabe von rechtswert/Hochwert zusätzlich auf den Kartenausschnitt zoomen
    if (rechtswert != null && hochwert != null) {
      var boundingBox = [
        rechtswert - 100,
        hochwert - 30,
        rechtswert + 100,
        hochwert + 30,
      ];
      this._sendGDARequestWhenReady(() => {
        this.gdaProxy.postMessage({
          action: "zoomTo",
          obj: boundingBox,
        });
      });
    }
  }

  /* Methode zum Zoomen eines Kartenausschnitts */
  zoomKarte(boundingBox: any, finalScale: any) {
    this._openGDAPopup();

    if (boundingBox != null) {
      this._sendGDARequestWhenReady(() => {
        this.gdaProxy.postMessage({
          action: "zoomTo",
          obj: boundingBox,
          finalScale: finalScale,
        });
      });
    }
  }

  // ------ PRIVATE METHODS-------


  /** öffnen eines GDA-Fensters (sofern noch nicht geöffnet) */
  _openGDAPopup() {
    if (this.gdaProxy == null)
      throw new Error(
        "Die GDA Verbindung ist noch nicht vollständig initialisiert.",
      );
    else {
      var windowClosed = false;
      try {
        windowClosed = this.gdaPoupWindow == null || this.gdaPoupWindow.closed;
      } catch (ex) {
        windowClosed = true;
      }

      if (windowClosed) {
        // this allows to open new windows if the popup was closed
        var externalBlankPageUrl = this.config.externalBaseUrl + "blank.html";
        var mainapp = "mainapp" + new Date().getTime();
        var _gdaPoupWindow = window.open(
          "/blank.html",
          mainapp,
          this.config.winOpts,
        );
        _gdaPoupWindow = window.open(
          externalBlankPageUrl,
          mainapp,
          this.config.winOpts,
        );
        this.gdaPoupWindow = _gdaPoupWindow;

        var gdaPoupWindowTimer = setInterval(() => {
          if (this.gdaPoupWindow != null) {
            clearInterval(gdaPoupWindowTimer);
            this.gdaProxy.open(mainapp);
            this.gdaPoupWindow.focus();
          }
        }, 1000);
      }else{
          this.gdaPoupWindow?.focus();
      }
    }
  }


  _openGDAPopupUrl(url: string) {
    if (this.gdaProxy == null)
      throw new Error(
          "Die GDA Verbindung ist noch nicht vollständig initialisiert.",
      );
    else {
      var windowClosed = false;
      try {
        windowClosed = this.gdaPoupWindow == null || this.gdaPoupWindow.closed;
      } catch (ex) {
        windowClosed = true;
      }

      if (windowClosed) {
        var mainapp = "mainapp" + new Date().getTime();
        var _gdaPoupWindow = window.open(
            "/blank.html",
            mainapp,
            this.config.winOpts,
        );
        _gdaPoupWindow = window.open(
            url,
            mainapp,
            this.config.winOpts,
        );
        this.gdaPoupWindow = _gdaPoupWindow;
      }else{
        this.gdaPoupWindow?.focus();
        this.gdaPoupWindow?.location.replace(url);
      }
    }
  }

  /**
   * Wrapper-Methode für alle XDM-Aufrufe an GDA Wasser. Die Aufrufe werden in einer Queue gepuffert,
   * bis GDA sich als betriebsbereit erklärt, und erst dann sukzessive aufgearbeitet
   */
  _sendGDARequestWhenReady(callback: any) {
    //Funktionsaufruf zur Queue hinzufügen
    this.functionQueueWaitForReady.push(callback);
    //console.log("sendGDARequestWhenReady: function in queue aufgenommen: "+callback);
    if (this.gisReadyTimer == null) {
      //wenn keine Timer -> Queueverarbeitung starten
      var i=0;
      this.gisReadyTimer = setInterval(() => {
        if (this.gdaPoupWindow == null || this.gdaPoupWindow.closed) {
          //wenn Fenster geschlossen -> Intervall abbrechen
          //bei geschlossenem Fenster alles resetten
          //console.log("fenster geschlossen, lösche timer");
          clearInterval(this.gisReadyTimer);
          this.gisReadyTimer = null;
          this.functionQueueWaitForReady = [];
          return;
        }
        if (this.functionQueueWaitForReady.length == 0) {
          //wenn alle Funktionen in der Queue abgearbeitet sind, Interval stoppen
          //console.log("queue abegearbeitet, lösche timer");
          clearInterval(this.gisReadyTimer);
          this.gisReadyTimer = null;
          return;
        }
        //ansonsten immer weiter isGISReady feuern...
        this.gdaProxy.postMessage({
          action: "isGisReady",
        });
        if(i++>15)   clearInterval(this.gisReadyTimer);
      }, 1000);
    }
  }

  /** Initialisierung der Schnittstelle zu GDA Wasser */
  _initGDAClient() {
    var _dspfTicket = eval("dspfTicket")||'';

    var externalRemoteHelperUrl = this.config.externalBaseUrl + "name.html";
    var externalRemoteUrl =
      this.config.externalBaseUrl +
      "remote.html?applicationId=" +
      this.config.externalApplicationId +
      "&dspf_user_id=" +
      this.config.dspfUserId +
      "&ticket=<ticket>&";
    externalRemoteUrl = externalRemoteUrl.replace(
      "<ticket>",
      encodeURIComponent(_dspfTicket),
    );

    //Initialisierung der GDA Verbindung
    // @ts-ignore
    this.gdaProxy = new window.easyXDM.Rpc(
      {
        remote: externalRemoteUrl,
        remoteHelper: externalRemoteHelperUrl,
      },
      {
        remote: {
          open: {},
          postMessage: {},
        },
        local: {
          postMessage: (data: any) => {
            //console.log(data.isGisReady);
            if (data.isGisReady) {
              //Antwort auf eine isGISReady-Anfrage: Funktion kann nun gefeuert werden
              //console.log("gda_client_api: GISReady recieved: "+ data.isGisReady);
              if (this.functionQueueWaitForReady.length > 0) {
                //Queue-Function ausführen!
                //console.log("gda_client_api: calling function from Queue: "+functionQueueWaitForReady[0]);
                var thisFunction = this.functionQueueWaitForReady.shift(); //Funktion aus Queue löschen
                if(thisFunction) thisFunction(); //Funktion aus Queue ausführen
                //console.log("gda_client_api: verbleibende Funktionen in der Queue: "+functionQueueWaitForReady.length);
              }
            }

            //Entgegennehmen einer Return-Koordinate
            if (data.COORD) {
              var ks = data.COORD.split(",");
              if (ks.length == 2) {
                this.config.recieveCoordinate(
                  parseFloat(ks[0]).toFixed(1),
                  parseFloat(ks[1]).toFixed(1),
                );
                if(this.gdaPoupWindow)
                this.gdaPoupWindow.close();
              }
            }

            //"Zurück Button Pressed in Read-Only-Window" -> Close Window
            if (data.UPDATE == false && data.MODE == "UNSET") {
              if(this.gdaPoupWindow)
              this.gdaPoupWindow.close();
            }
          },
        },
      },
    );
  }

  _getScript(scriptUrl: string, callback: any) {
    const script = document.createElement("script");
    script.src = scriptUrl;
    script.onload = callback;

    document.body.appendChild(script);
  }
}
